import { AxiosInstance } from 'axios';
import axiosClient from './axiosClientConfig';
import {
	ConfirmNewPasswordPayload,
	HttpResponse,
	UserI,
	UserPayload,
	UserSignIn,
	UserSignUp,
} from 'interfaces';

/**
 * This class should hold all the routes to the endpoints that are
 * related to authentication, routes might change depending on the project
 * so its needed to check those before using it
 */
class Auth {
	constructor(private client: AxiosInstance) {}

	async login(
		email: string,
		password: string
	): Promise<HttpResponse<UserSignIn>> {
		return this.client.post('/auth/sign-in', { email, password });
	}

	async loginWallet(address: string): Promise<HttpResponse<UserI>> {
		return this.client.post('/auth/login/wallet', { address });
	}

	async signUp(userData: UserPayload): Promise<HttpResponse<UserSignUp>> {
		return this.client.post('/auth/sign-up', userData);
	}

	async resendVerificationEmail(email: string): Promise<HttpResponse<UserI>> {
		return this.client.post('/auth/resend-verification-email', { email });
	}

	async verifyProfile(code: string): Promise<HttpResponse<UserI>> {
		return this.client.post('/auth/verify-profile', { code });
	}

	// Forgot password
	async forgotPassword(email: string): Promise<HttpResponse<UserI>> {
		return this.client.post('/auth/forgot-password', { email });
	}
	async verifyRecoveryPasswordCode(code: string): Promise<HttpResponse<UserI>> {
		return this.client.post('/auth/verify-recovery-password-code', { code });
	}
	async confirmNewPassword(
		data: ConfirmNewPasswordPayload
	): Promise<HttpResponse<UserI>> {
		return this.client.post('/auth/confirm-new-password', data);
	}

	// Recover account
	async recoverAccount(
		email: string
	): Promise<HttpResponse<{ message: string }>> {
		return this.client.post('/auth/recover-account', { email });
	}
	async resendRecoverAccountEmail(
		email: string
	): Promise<HttpResponse<{ message: string }>> {
		return this.client.post('/auth/resend-recover-account-email', { email });
	}
	async verifyRecoverAccountCode(
		code: string
	): Promise<HttpResponse<{ message: string }>> {
		return this.client.post(`/auth/verify-recover-account-code`, { code });
	}
	async confirmRecoverAccount(code: string, password: string) {
		return this.client.post('/auth/confirm-recover-account', {
			code,
			password,
		});
	}

	async getUserActiveStatus(
		id: string
	): Promise<HttpResponse<{ activated: boolean }>> {
		return this.client.get(`/auth/check-account/${id}`);
	}

	async recoverSocialAccount(
		email: string
	): Promise<
		HttpResponse<{ message: string; accessToken: string; refreshToken: string }>
	> {
		return this.client.post('/auth/recover-social-login-account', { email });
	}

	async recoverSocialAccountById(id: string) {
		return this.client.post('/auth/recover-account-by-id', { id });
	}
}

export const authService = new Auth(axiosClient);
